module.exports = __webpack_public_path__ + "static/google-play-badge-f0c185d5d352d0b0116dd70ad7638ad8.svg";